import React from 'react'

import { PhoneNumber } from 'src/refactor/components/IconTextComponent'
import { ItemData } from 'src/context/results/types'

import { TResultListItemProps } from './types'
import {
  RliAddress,
  RliContainer,
  RliDistance,
  RliTitle,
} from './ResultListItem.styled'

export const FacilityResultListItem = React.forwardRef<
  HTMLDivElement,
  ItemData & TResultListItemProps
>(
  (
    {
      practiceName,
      distance,
      address1,
      fullAddress,
      phone,
      togglePopup,
      style,
      id,
    },
    ref
  ) => {
    const onHover = () => togglePopup(id)

    return (
      <RliContainer
        ref={ref}
        onMouseEnter={onHover}
        onMouseLeave={onHover}
        style={style}
      >
        <RliTitle>{practiceName}</RliTitle>
        <RliDistance>{distance} mi</RliDistance>

        <RliAddress>{address1}</RliAddress>
        <RliAddress>{fullAddress}</RliAddress>

        <PhoneNumber number={phone as string} />
      </RliContainer>
    )
  }
)
